import { render } from "./decoratedtitle.vue?vue&type=template&id=fbc7c924&scoped=true"
import script from "./decoratedtitle.vue?vue&type=script&lang=js"
export * from "./decoratedtitle.vue?vue&type=script&lang=js"

import "./decoratedtitle.vue?vue&type=style&index=0&id=fbc7c924&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc7c924"]])

export default __exports__